import { bl_inv_stock_replenishment_run_order_qty_line_RowClass } from '../../../dbschema/bl_inv_stock_replenishment_run_order_qty_line.model';
import { BaseContainerModel } from '../../base-container.model';


export class StockReplenishmentRunOrderQtyLineModel extends BaseContainerModel {
  bl_inv_stock_replenishment_run_order_qty_line: bl_inv_stock_replenishment_run_order_qty_line_RowClass = new bl_inv_stock_replenishment_run_order_qty_line_RowClass();
}
